import { render } from "./AdminTransactionsView.vue?vue&type=template&id=bf0b1502&scoped=true"
import script from "./AdminTransactionsView.vue?vue&type=script&lang=js"
export * from "./AdminTransactionsView.vue?vue&type=script&lang=js"

import "./AdminTransactionsView.vue?vue&type=style&index=0&id=bf0b1502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0b1502"]])

export default __exports__